import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import { setMenuSelected, setMenuSelected_2 } from '@redux/actions/menuAction';
import moment from 'moment';
import { DATE_FORMAT } from 'config';
import {
  getList,
  deleteOne,
  exportData,
} from 'api/environmentProtectionWorkApi';
import slug from 'constants/slug';
import styled from 'styled-components';
import Message from 'rc-message';
import _ from 'lodash';
import { createForm } from 'rc-form';
import PageLockHOC from 'hoc/pageLock';
import { COLOR } from 'config';
import { getLabelIndustrialArea } from 'utils/misc';
import { IS_ENTERPRISE } from 'config';

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;

@PageLockHOC(['environmentProtectionWork.view'])
class EnvironmentProtectionWorkList extends BaseListContainer {
  static propTypes = {
    facilityId: PropTypes.string,
    hideRightHeaderContent: PropTypes.bool,
  };

  constructor(props) {
    const funcApi = {
      getList,
      exportData,
    };
    const columns = [
      {
        dataField: 'facility.FacilityNameFull',
        text: 'Tên cơ sở/dự án',
        formatter: (cell, row) => {
          return (
            <Link
              target='_blank'
              to={slug.ENVIRONMENT_PROTECTION_WORK.VIEW_WITH_ID + row._id}
              onClick={() => {
                this.props.setMenuSelected_2(null);
              }}
            >
              <NameContainer>{cell}</NameContainer>
            </Link>
          );
        },
      },
      ...(!IS_ENTERPRISE && [
        {
          dataField: 'facility.organizationName',
          text: 'Tên doanh nghiệp',
          formatter: (cell, row) => {
            return <div style={{ width: 200 }}>{cell ? cell : ''}</div>;
          },
        },
      ]),
      {
        dataField: 'facility.industrialArea',
        text: getLabelIndustrialArea(),
        formatter: (cell, row) => {
          return <div>{cell ? cell.Name : ''}</div>;
        },
      },
      {
        dataField: 'facility.sector',
        text: 'Ngành/Nghề',
        formatter: (cell, row) => {
          return <div>{cell ? cell.Name : ''}</div>;
        },
      },
      {
        dataField: 'YearReport',
        text: 'Năm báo cáo',
        formatter: (cell, row) => {
          return <div>{cell}</div>;
        },
      },
      {
        dataField: 'DateFiling',
        text: 'Ngày nộp',
        formatter: (cell, row) => {
          if (!cell) return '';
          return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
        },
      },
      {
        dataField: 'Chemistries',
        text: 'Loại chất thải',
        formatter: (cell, row) => {
          if (cell && cell.length) {
            return cell.map((item, index) => {
              let str = _.get(item, 'chemistryType.Name', '');
              if (_.get(item, 'chemistry')) {
                str = _.get(item, 'chemistry.Name', '');
              }
              return (
                <div key={index}>
                  {str} <br />
                </div>
              );
            });
          } else {
            return '';
          }
        },
      },
    ];

    super(
      props,
      funcApi,
      columns,
      `${slug.ENVIRONMENT_PROTECTION_WORK.CREATE}`,
      'environmentProtectionWork',
      null,
      false,
      false
    );

    this.state = {
      ...this.state,
      valueSearch: {
        facility: this.props.facilityId,
      },
    };
  }

  renderSearchContainer() {
    return <div>{super.renderSearchContainer()}</div>;
  }

  handelDelete = (_id) => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      this.ConfirmElm.showConfirm({
        content: 'Bạn có muốn xoá ',
        cb: async (value) => {
          if (value) {
            const res = await deleteOne(_id);
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              this.fetData();
            }
            if (res.error) Message.error({ content: res.message });
          }
        },
      });
    }
  };

  handelSubmitSearch(values) {
    values.year = _.get(values.year, 'value');
    values.permitType = _.get(values.permitType, 'value');
    super.handelSubmitSearch(values);
  }
}

const mapStateToProps = (state) => ({
  menuStore: state.menu,
});

const mapDispatchToProps = {
  setMenuSelected,
  setMenuSelected_2,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(createForm()(EnvironmentProtectionWorkList))
);



// WEBPACK FOOTER //
// ./src/containers/environment-protection-work/environment-protection-work-List/index.js